import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import prefix from '../../utils/prefix';
import './styles.sass';
var modifiers = prefix('checkbutton--');
var CheckButton = function CheckButton(_ref) {
  var children = _ref.children,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    role = _ref.role,
    dataTest = _ref.dataTest;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('checkbutton', modifiers({
      checked: checked
    })),
    role: role,
    "aria-checked": checked,
    disabled: disabled,
    "data-test": dataTest
  }, !disabled && onChange && {
    onClick: function onClick() {
      return onChange(!checked);
    }
  }), children);
};
CheckButton.propTypes = {
  children: PropTypes.node,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  role: PropTypes.string,
  dataTest: PropTypes.string
};
CheckButton.defaultProps = {
  role: 'checkbox' // accessibility purposes
};
export default CheckButton;
//# sourceMappingURL=index.js.map
